// Load the bootstrap bundle version, as this includes Popper
import Modal from 'bootstrap/js/dist/modal';
import $ from 'jquery';

export default {
    init() {

        // attach click listener
        $("[data-syn-toggle='modal']").click((e) => {
            e.preventDefault();

            let button  = e.currentTarget;
            let modalEl = document.getElementById(button.getAttribute('data-syn-modal-id'));

            if(modalEl === null) {
                console.warn('Could not open modal, no element found. Make sure data-syn-modal-id target an existing element with the proper id attribute.', button.getAttribute('data-syn-modal-id'));
                return false;
            }

            $(button).addClass("loading");

            var ajax    = button.getAttribute('data-syn-modal-ajax');
            var url     = ajax === 'true' && typeof button.getAttribute('href') === 'string' ?
                button.getAttribute('href')
                :
                ajax;

            $.ajax({
                url: url,
                type: "GET",
                success: ( responseText ) => {
                    $(modalEl).html(responseText);
                    let modal = new Modal(modalEl, {});
                    modal.show();
                },
                complete: function () {
                    $(button).removeClass("loading");
                }
            });
        });

        return this;
    },

    show(element, options = {}) {
        let modal = new Modal(element, options);
        modal.show();
    },

    hide(element, options = {}) {
        let modal = new Modal(element, options);
        modal.hide();
    },

    showUrl(url, element = document.getElementById('default-modal'), options = {}) {

        // don't show if the element is already shown
        if(element.classList.contains("show")) {
            return;
        }

        $.ajax({
            url: url,
            type: "GET",
            success: ( responseText ) => {
                $(element).html(responseText);
                let modal = new Modal(element, options);
                modal.show();
            }
        });
    }
}